import _ from "lodash";
import Vue from "vue";

import AnalyticsApi from "@/api/analyticsApi";
import { mapAnalyticsDataByMachineFamily } from "@/stores/helpers/analyticsHelper";
import { isFullLicenseEnabled } from "@/stores/helpers/machinesHelper";

export default {
  state: {
    analytics: {}
  },
  getters: {
    getAnalytics: state => state.analytics,
    getAnalyticsById: state => id => {
      return state.analytics[id];
    },
    getAnalyticsByMachine: (state, getters) => machine => {
      const id = machine && machine.Id;
      return getters.getAnalyticsById(id);
    }
  },
  actions: {
    async fetchAnalytics({ commit }, { machines, filters }) {
      const api = new AnalyticsApi();

      // Only connected machines has analytics
      const onlyMachinesWithAnalytics = machines.filter(
        machine => !_.isEmpty(machine.Device) && isFullLicenseEnabled(machine)
      );

      if (machines.length > 0) {
        let analytics = undefined;
        try {
          analytics = await api.getAnalyticsByMachines({
            machines: onlyMachinesWithAnalytics,
            ...filters
          });

          if (analytics) {
            analytics = analytics.reduce((acc, el) => {
              const { MachineId } = el;
              const data = mapAnalyticsDataByMachineFamily(
                machines.find(m => m.Id === MachineId),
                el
              );
              acc[MachineId] = data;
              return acc;
            }, {});
          }
        } catch (e) {
          console.error("[Error] Get analytics by machine failed.", e);
        }

        commit("SET_ANALYTICS", analytics);
      }
    }
  },
  mutations: {
    SET_ANALYTICS: (state, analytics) => {
      if (analytics) {
        Vue.set(state, "analytics", { ...state.analytics, ...analytics });
      }
    }
  },
  namespaced: true
};
